export const SHOW_MODAL_POPUP = "SHOW_MODAL_POPUP";
export const HIDE_MODAL_POPUP = "HIDE_MODAL_POPUP";
export const ROUTE_CHANGED = "ROUTE_CHANGED";
export const REFRESH_PAGE_INIT = "REFRESH_PAGE_INIT";
export const EPISODE_ID_CHANGED = "EPISODE_ID_CHANGED";
